/* eslint-disable @typescript-eslint/no-explicit-any */
import {GOOGLE_ANALYTICS_EVENTS, HUBSPOT} from './constants';
import isHubspotForm from './utils/isHubspotForm';

type Maybe<T> = T | null;
type SubmitElement = HTMLButtonElement | HTMLInputElement;

const getFormSubmitElement = (form: HTMLFormElement): Maybe<SubmitElement> =>
  form.querySelector('input[type="submit"], button[type="submit"], button');

export const hubspotFormSubmit = ({target, submitter}: SubmitEvent) => {
  if (!isHubspotForm(target)) return;

  const form = target as HTMLFormElement;
  const {formId} = form.dataset;

  const submitElement = (submitter || getFormSubmitElement(form)) as Maybe<SubmitElement>;
  const clickText = submitElement?.value;

  (window as any).dataLayer.push({
    event: GOOGLE_ANALYTICS_EVENTS.FORM_SUBMIT,
    form_id: formId ?? '',
    form_host: HUBSPOT,
    click_text: clickText ?? '',
  });
};

const registerHubspotFormSubmit = (element: Maybe<HTMLElement>) => {
  if (!isHubspotForm(element)) return;

  (element as HTMLFormElement).addEventListener('submit', hubspotFormSubmit);
};

export default registerHubspotFormSubmit;
